<template>
    <span :class="badgeClass">
        <slot></slot>
        <i class="bi bi-x-circle ms-2 close-icon" @click="$emit('remove')"></i>
    </span>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
    name: "BadgeWithClose",
    props: {
        label: { type: String, required: true }, // Tekst w badge
        variant: { type: String, default: "primary" }, // Kolor badge (np. primary, success, danger)
    },
    emits: ["remove"], // Wysyła event po kliknięciu "X"
    setup(props) {
        const badgeClass = computed(() => `badge bg-${props.variant} d-flex align-items-center`);
        return { badgeClass };
    },
});
</script>

<style scoped>
.close-icon {
    cursor: pointer;
}
</style>